export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/emotes_badges.62c9d30.svg";